
import { Vue, Component, Prop } from 'vue-property-decorator';
import { redirectTo } from '@/features/common/helpers';

@Component
export default class NavSubItem extends Vue {
  @Prop({ default: '' }) to!: string;

  @Prop({ default: false }) absolute!: boolean;

  @Prop({ default: undefined }) id!: string | undefined;

  private redirectTo = redirectTo;
}
